import React, { useState, useEffect, useCallback } from 'react'
import { Pagination, Row, Col, Collapse, Table } from 'antd'
import axios from 'axios'
import PageHeader from '../Layout/PageHeader'
import OtpFilters from './OtpFilters'
import { CaretRightOutlined } from '@ant-design/icons'
import { formatDateTime } from "../../helpers/date";
import moment from "moment";

const Otp = () => {
    const [pagination, setPagination] = useState({ currentPage: 1, limit: 10 })
    const [otp, setOtp] = useState([])
    const [filters, setFilters] = useState({
        sentTo: null,
    })
    const [isLoading, setIsLoading] = useState(false)

    const fetchOtp = useCallback(async () => {
        setIsLoading(true)

        const params = {
            ...(filters.sentTo !== null) && { sentTo: filters.sentTo },
            limit: pagination.limit,
            page: pagination.currentPage
        }

        const res = await axios.get("otp-logs", { params })

        setOtp(res.data.data)
        setPagination(res.data.pagination)
        setIsLoading(false)
    }, [pagination.currentPage, pagination.limit, filters])

    const columns = [
        {
            title: "Sent To",
            dataIndex: "sentTo",
        },
        {
            title: "Code",
            dataIndex: "code",
        },
        {
            title: "Sent At",
            dataIndex: "sentAt",
            render: (sentAt) => (sentAt ? formatDateTime(sentAt) : "-"),
        },
        {
            title: "Is OTP Expired",
            dataIndex: "sentAt",
            render: (sentAt) => {
                const expiredAt = moment(sentAt.iso).add(5, 'm')
                const now = moment();

                return now.isAfter(expiredAt) ? "Yes" : "No";
            },
        },
        {
            title: "Is Verified",
            dataIndex: "user",
            render: (user) => user?.phoneVerifiedOn?.iso ? "Yes" : "No",
        }
    ];

    useEffect(() => {
        fetchOtp()
    }, [pagination.currentPage, pagination.limit, fetchOtp])

    return (
        <div>
            <PageHeader
                title="Otp"
                childRoutes={[{ path: "/otp", breadcrumbName: "Otp" }]}
            />

            <Collapse expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}>
                <Collapse.Panel header="Filters" key="filters">
                    <OtpFilters
                        filters={filters}
                        onFiltersChange={filters => setFilters(filters)}
                    />
                </Collapse.Panel>
            </Collapse>

            <Row justify="end">
                <Col>
                    <Pagination
                        total={pagination?.totalSize}
                        pageSize={pagination?.limit}
                        onChange={((currentPage, limit) => { setPagination({ ...pagination, limit, currentPage }) })}
                        current={pagination.currentPage}
                    />
                </Col>
            </Row>

            <Table
                rowKey="otpId"
                pagination={false}
                columns={columns}
                dataSource={otp}
                loading={isLoading}
                scroll={{x:1000, y:500}}
            />

            <Row justify="end">
                <Col>
                    <Pagination
                        total={pagination?.totalSize}
                        pageSize={pagination?.limit}
                        onChange={((currentPage, limit) => { setPagination({ ...pagination, limit, currentPage }) })}
                        current={pagination.currentPage}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default Otp